import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import QueryString from "query-string";
import "./Thumbnail.css";
import { API_URL } from "../config/index";
import toast from "react-hot-toast";
import secureLocalStorage from "react-secure-storage";
const Thumbnail = () => {
  const location = useLocation();
  const navigate = useNavigate();

  console.log("Location", location);
  useEffect(() => {
    const values = QueryString.parse(location.search);

    if (values.success) {
      const sessionId = values.session_id;
      const id = secureLocalStorage.getItem("Id");
      sendSessionIdToBackend(sessionId, id);
    }

    if (values.canceled) {
      console.log(
        "Order canceled -- continue to shop around and checkout when you're ready."
      );
    }
  }, [location]);

  const sendSessionIdToBackend = (sessionId, id) => {
    fetch(`${API_URL}/get-sessionId`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ session_id: sessionId, user: id }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to send session ID to backend");
        }
        return response.json();
      })
      .then((data) => {
        console.log(data);
        if (data.success) {
          const subInfo = {
            plan: data.Title,
            account_type: data.AccountType,
            date: data.Date,
          };
          secureLocalStorage.setItem("Subscription", true);
          secureLocalStorage.setItem("SubInfo", JSON.stringify(subInfo));
          secureLocalStorage.setItem("Status", "paid");
          navigate("/subscriber");
        } else {
          toast.error("Failed to Send Email");
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  return (
    <div className="thumbnail">
      <div>
        <div className="wrapper-background">
          <img
            className="background-icon-success"
            alt=""
            src="/background.svg"
          />
          <img className="robot-image" alt="" src="/Robot3.png" />
        </div>
        <h1 className="thank-you">Thank You</h1>
        <h1 className="for-subscribing-forex-container">
          <p className="for-subscribing-forex">For Subscribing Forex Miner</p>
        </h1>
        <h1 className="youll-be-redirected">You'll be notified.</h1>
        <h1 className="kinldy-wait-for">Kindly wait for confirmation</h1>
        <h1 className="team-forex-miner">
          If succeed, we will send bot link to your email
        </h1>
        <img
          className="thumbnail-child"
          loading="lazy"
          alt=""
          src="/group-4.svg"
        />
      </div>
    </div>
  );
};

export default Thumbnail;
